<template>
  <div class="fb-eoc-vitals-v2">
    <div v-if="showType == 'form-builder'" :style="properties.style">
      <b-form-group
        :description="computedPropertiesForm.description"
        :label="computedPropertiesForm.label"
        :style="properties.style"
      >
        <b-table
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div v-else-if="showType == 'properties'">
      <eoc-vitals-v2-properties :formId="formId" />
    </div>
    <div
      v-if="showType == 'form-submitter' && page == currentPage"
      :style="properties.style"
    >
      <b-form-group
        style="font-size: 14px"
        :description="computedPropertiesForm.description"
        :style="properties.style"
        v-show="!computedHidden"
      >
        <template v-slot:label="">
          <div class="d-flex align-items-center mb-3">
            <span class="mr-3">
              {{
                computedPropertiesForm.label
              }}
            </span>
            <b-form-select
              v-if="!properties.hidePicker"
              v-model="controlValue"
              :options="options"
              style="width: 450px; font-size: 14px"
            />
          </div>
        </template>
        <b-table
          v-if="controlValue"
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
      </b-form-group>
    </div>
    <div v-if="showType == 'form-viewer'" :style="properties.style">
       <b-table
          responsive
          :items="tableProperties.items"
          :fields="tableProperties.columns"
        ></b-table>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { formatDate } from "../../../../helpers/date";
import EocVitalsV2Properties from "./EocVitalsV2Properties.vue";
import vitalRecordServer from "../../../../server/vitalRecord";
export default {
  name: "EocVitalsV2",
  components: { EocVitalsV2Properties },
  props: ["showType", "properties", "form", "id", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden"],
      computedConditions: {},
      vitalRecords: [],
    };
  },
  async mounted() {
    if (this.showType == "e-form") {
      return;
    }

    if (
      this.showType != "form-builder" &&
      (this.showType == "form-submitter" || this.showType == "e-form")
    ) {
      const vitals = await vitalRecordServer.query(
        false,
        this.client.episodeOfCare.id
      );

      this.vitalRecords = vitals
        .sort((a, b) => {
          return a.effectiveDate.localeCompare(b.effectiveDate);
        })
        .reverse()
        .map((vital) => {
          let vitalItems = "";
          for (let index = 0; index < vital.items.length; index++) {
            const item = vital.items[index];
            vitalItems += `${item.vitalSign.name}: ${item.value}\n`;
          }
          return {
            effectiveDate: formatDate(vital.effectiveDate),
            user: vital.user ? this.formatUser(vital.user) : "",
            items: vitalItems,
            id: vital.id,
          };
        });
    }

    if (this.showType != "form-builder") {
      if (!this.controlValue) {
        this.controlValue = this.vitalRecords.length
          ? this.options[1].value
          : this.options[0].value;
      }
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
   getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      console.log("getting baked layout");
      const hidden = this.getComponentComputedProperties("hidden");

      if (hidden === true) return "";

      return `
      <fieldset aria-describedby="" class="form-group is-table" id="__BVID__48">
        <legend style="font-size:14px;" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0" id="__BVID__48__BV_label_">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <div>
            <div>
              <table role="table" aria-busy="false" aria-colcount="3" class="table b-table custom-fb-table mt-2 table-striped table-responsive table-hover" id="__BVID__50">
                <thead role="rowgroup" class="">
                  <tr role="row" class="">
                    <th role="columnheader" scope="col" aria-colindex="1" class="">
                      <div style="font-size:14px;">Date</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="2" class="">
                      <div style="font-size:14px;">Creator</div>
                    </th>
                    <th role="columnheader" scope="col" aria-colindex="3">
                      <div style="font-size:14px;">Vitals</div>
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                ${(this.tableProperties.items || [])
                  .map(
                    (item) => `
                  <tr role="row" class="">
                    <td style="font-size:14px;" aria-colindex="1" role="cell" class="">${item.effectiveDate}</td>
                    <td style="font-size:14px;" aria-colindex="2" role="cell" class="">${item.user}</td>
                    <td style="font-size:14px;" aria-colindex="3" role="cell" class="pre-wrap">${item.items}</td>
                  </tr>
                `
                  )
                  .join("")}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </fieldset>`;
    },
  },
  computed: {
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    ...mapState("formSubmitter", {
      client: (state) => state.form.client,
      currentPage: (state) => state.form.currentPage,
    }),
    ...mapGetters("client", ["vitalSignsCurrentLocation"]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    options() {
      const options = this.vitalRecords.map((u) => ({
        value: { id: u.id, text: `${u.effectiveDate} by ${u.user}` },
        text: `${u.effectiveDate} by ${u.user}`,
      }));

      options.unshift({ value: { id: "all", text: "All" }, text: "All" });

      return options;
    },
    vitalSigns() {
      return this.vitalSignsCurrentLocation.filter(
        (vitalSign) => vitalSign.status == "Enabled"
      );
    },
    tableProperties() {
      let items = this.vitalRecords.slice();
      if (
        this.vitalRecords.length &&
        this.controlValue &&
        !this.properties.hidePicker
      ) {
        items =
          this.controlValue.id == "all"
            ? this.vitalRecords.slice()
            : [this.vitalRecords.find((u) => u.id == this.controlValue.id)];
      }

      return {
        ...this.properties,
        items: items,
        columns: [
          {
            key: "effectiveDate",
            label: "Date",
          },
          {
            key: "user",
            label: "Creator",
          },
          {
            key: "items",
            label: "Vitals",
            class: "pre-wrap",
          },
        ],
      };
    },
    controlValue: {
      get() {
        if (this.results) return this.results[this.id];
        return this.getFormSubmitterComponentValue(this.id);
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newControlValue,
            userAction: true,
            hardSet: true,
            hasUnsavedChanges: this.controlValue ? true : false,
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newControlValue,
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true,
            });
          }
        }
      },
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden;

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    },
  },
};
</script>
